import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-ink text-bone grain relative" data-testid="site-footer">
      <div className="max-w-[1240px] mx-auto px-6 md:px-10 lg:px-14 py-20 md:py-24 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12">
          <div className="md:col-span-5">
            <img
              src="https://customer-assets.emergentagent.com/job_dugavu-staging/artifacts/t29z1os5_Dugavu%20logo%203.png"
              alt="Dugavu Ventures"
              className="h-32 md:h-36 w-auto object-contain"
              style={{ filter: "brightness(0) invert(1)" }}
            />
            <p className="mt-6 max-w-md text-bone/70 leading-relaxed text-[15px]">
              A specialist strategy advisory firm working with boards, chief executives, and ministerial leadership across Africa.
            </p>
            <div className="mt-8 text-[12px] tracking-widest uppercase text-bone/50 font-mono">
              Kampala, Uganda
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] tracking-widest uppercase text-earth font-mono mb-5">Navigate</div>
            <ul className="space-y-3 text-[14px]">
              <li><Link to="/practice" className="text-bone/80 hover:text-bone link-underline" data-testid="footer-nav-practice">Practice</Link></li>
              <li><Link to="/sectors" className="text-bone/80 hover:text-bone link-underline" data-testid="footer-nav-sectors">Sectors</Link></li>
              <li><Link to="/approach" className="text-bone/80 hover:text-bone link-underline" data-testid="footer-nav-approach">Approach</Link></li>
              <li><Link to="/about" className="text-bone/80 hover:text-bone link-underline" data-testid="footer-nav-about">About</Link></li>
              <li><Link to="/insights" className="text-bone/80 hover:text-bone link-underline" data-testid="footer-nav-insights">Insights</Link></li>
              <li><Link to="/contact" className="text-bone/80 hover:text-bone link-underline" data-testid="footer-nav-contact">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] tracking-widest uppercase text-earth font-mono mb-5">Contact</div>
            <ul className="space-y-3 text-[14px]">
              <li>
                <a href="mailto:mandates@dugavuventures.com" className="text-bone/80 hover:text-bone link-underline" data-testid="footer-email-mandates">
                  mandates@dugavuventures.com
                </a>
                <div className="text-[11px] text-bone/50 mt-0.5 tracking-wide uppercase font-mono">Mandates</div>
              </li>
              <li>
                <a href="mailto:rfp@dugavuventures.com" className="text-bone/80 hover:text-bone link-underline" data-testid="footer-email-rfp">
                  rfp@dugavuventures.com
                </a>
                <div className="text-[11px] text-bone/50 mt-0.5 tracking-wide uppercase font-mono">Procurement</div>
              </li>
              <li>
                <a href="mailto:info@dugavuventures.com" className="text-bone/80 hover:text-bone link-underline" data-testid="footer-email-info">
                  info@dugavuventures.com
                </a>
                <div className="text-[11px] text-bone/50 mt-0.5 tracking-wide uppercase font-mono">General</div>
              </li>
              <li>
                <a href="mailto:press@dugavuventures.com" className="text-bone/80 hover:text-bone link-underline" data-testid="footer-email-press">
                  press@dugavuventures.com
                </a>
                <div className="text-[11px] text-bone/50 mt-0.5 tracking-wide uppercase font-mono">Press</div>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-bone/15 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div className="text-[12px] text-bone/55 leading-relaxed">
            © {year} Dugavu Ventures Ltd · Kampala, Uganda <br className="md:hidden" />
            <span className="md:ml-2">Affiliated with Dagala Group, United Kingdom</span>
          </div>
          <div className="flex items-center gap-6 text-[12px]">
            <Link to="/privacy" className="text-bone/70 hover:text-bone link-underline" data-testid="footer-privacy">Privacy Policy</Link>
            <Link to="/terms" className="text-bone/70 hover:text-bone link-underline" data-testid="footer-terms">Terms of Use</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
